












import { Component, Prop, Vue } from 'vue-property-decorator';

export enum SwitchActiveColor {
  Primary = 'switch__option--primary',
  Secondary = 'switch__option--secondary',
}

export enum ButtonSwitchPredefinedStyle {
  Standard = 'switch--standard',
  Responsive = 'switch--responsive',
}

@Component
export default class ButtonSwitch extends Vue {
  @Prop() private optionSelected!: any;
  @Prop() private options!: any[];
  @Prop({ default: ButtonSwitchPredefinedStyle.Standard }) private buttonSwitchPredefinedStyle!: ButtonSwitchPredefinedStyle;

  private emitClick(option: any) {
    this.$emit('option-selected', option);
  }

  private isActive(option: any) {
    let val = null;
    if (this.optionSelected) {
      val = this.optionSelected.id;
    } else if (this.options.length > 0) {
      val = this.options[0].id;
    }
    let result = '';
    if ( option.id === val ) {
      if ( option.activeColor ) {
        result = option.activeColor;
      } else {
        result = SwitchActiveColor.Secondary;
      }
    }
    return result;
  }
}

